import { Currency, ETHER, Token } from '@uniswap/sdk'
import { WRAPPED_NATIVE } from '../chainConfig'

function isEtherish(currency: Currency): boolean {
  return currency === ETHER || (currency instanceof Token && WRAPPED_NATIVE.equals(currency))
}

/**
 * Band-aid on maxHops because some tokens seems to always fail with multihop swaps
 * @param currencyIn currency in
 * @param currencyOut currency out
 */
export function maxHopsFor(currencyIn: Currency, currencyOut: Currency): number {
  if (isEtherish(currencyIn) && currencyOut instanceof Token && WRAPPED_NATIVE.equals(currencyOut)) {
    return 1
  } else if (isEtherish(currencyOut) && currencyIn instanceof Token && WRAPPED_NATIVE.equals(currencyIn)) {
    return 1
  }

  return 3
}
